import React, { useState,useEffect } from 'react';
import Helmet from 'react-helmet';
import { withTranslation } from 'react-i18next';
import PageTitle from '../../components/common/pageTitle';
import Spinner from '../../shared/Spinner';
import HistoryContent from '../../components/stockistHistory/historyContent';
import companyName from '../../../store/mobxStore/companyName';
import { useHistory, withRouter } from 'react-router';
import OrderService from '../../../service/stockist/Table';


function Stockist({t}) {
    let service = new OrderService()
    let history = useHistory()
    const [state, setState] = useState({
        loading: true,
        data: []
    })

    useEffect(() => { 
        service.getOrderHistory().then(res=>{
            if(res.status){
                setState({
                    loading  :false,
                    data  : res.data.order_details
                })
            }else{
                if(res.error.code === 1002){
                    history.push('/logout');
                }else if(res.error.code === 1057 ){
                    history.push({
                        pathname: '/dashboard',
                        state: {
                            error: true,
                            message : 'permissionDenied'
                        }
                    });
                }
            }
        }) 


     },[]);
     if(state.loading){
         return <Spinner />
     }
     return (
         <React.Suspense fallback={<Spinner/>}>
             <Helmet>
                 <title>{companyName.companyName} | {t('Sidemenu.stockHistory')}</title>
             </Helmet>
             <PageTitle title="stockHistory" buttonOn={false} />
             <HistoryContent
              
                 {...state}
             />
         </React.Suspense>
     )
}
export default withTranslation()(withRouter(Stockist))
